export const hdmgdjFeatures = [
  {
    id: "f-magic",
    icon: "ri-magic-line",
    title: "经典魔改 脑洞大开",
    desc: "把熟悉的经典桥段重新拆解演绎，反转密集、节奏明快，每一集都有新的惊喜等着你。",
    tone: "primary",
  },
  {
    id: "f-hd",
    icon: "ri-live-line",
    title: "全平台高清播放",
    desc: "Android、iOS、HarmonyOS、Windows 四端同步，1080P 高清画质随开随看。",
    tone: "accent",
  },
  {
    id: "f-free",
    icon: "ri-film-line",
    title: "海量短剧免费畅看",
    desc: "免费版下载后即可解锁海量剧场，每日爆更不断，追剧不花一分钱。",
    tone: "secondary",
  },
  {
    id: "f-offline",
    icon: "ri-download-cloud-2-line",
    title: "离线缓存 随时随地",
    desc: "一键缓存整部短剧，地铁、飞机上没有网络也能接着看。",
    tone: "primary",
  },
  {
    id: "f-recommend",
    icon: "ri-sparkling-2-line",
    title: "智能推荐 越看越懂你",
    desc: "根据观看口味精准推送，玄幻、甜宠、逆袭，总有让你上头的那一部。",
    tone: "accent",
  },
];